import { render, staticRenderFns } from "./SDKDashboard.vue?vue&type=template&id=604d3894&scoped=true"
import script from "./SDKDashboard.vue?vue&type=script&lang=ts"
export * from "./SDKDashboard.vue?vue&type=script&lang=ts"
import style0 from "./SDKDashboard.vue?vue&type=style&index=0&id=604d3894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d3894",
  null
  
)

export default component.exports